import React from 'react';
import PropTypes from 'prop-types';
import { generateRoutePath } from 'epic-common/src/route';
import SwiperButton from '../swiperButton/SwiperButton';
import Callout from '../callout/Callout';

const MapsSectionBlock = ({block, handlePrev, handleNext}) => {
    const { bgImage, headline, subheader, buttonText } = block;

    return (
        <div className="maps-section-block" style={{backgroundImage: `url('${bgImage}')`}}>
            <SwiperButton onClick={handlePrev} inverted />
            <div className="maps-section-block-content">
                <Callout
                    headline={headline}
                    description={subheader}
                    buttonText={buttonText}
                    buttonLink={generateRoutePath().replace('home', '')}
                    align="center"
                />
            </div>
            <SwiperButton onClick={handleNext} />
        </div>
    )
}

MapsSectionBlock.propTypes = {
    block: PropTypes.object,
    handlePrev: PropTypes.func,
    handleNext: PropTypes.func
}

MapsSectionBlock.defaultProps = {
    block: {},
    handlePrev: fn => fn,
    handleNext: fn => fn
};

export default MapsSectionBlock;
